export const Divider = () => {
  return (
    <div className="w-full grid grid-flow-col h-[1px] mt-7 mb-7">
      <span className="bg-[#E5E5EA] col-span-8"></span>
    </div>
  )
}
